import {
  MeasureBundleObject,
  shouldPromptForCSSRS,
} from "@grow-therapy-team/seedling-components";
import { useAtomValue, useSetAtom } from "jotai";
import { useCallback, useEffect } from "react";
import { toast } from "../../toasts";
import { roomAtom } from "../../video-sdk";
import { ProviderDrawerState, drawerStateAtom } from "../state";
import { CSSRSPromptToast } from "./CSSRSPromptToast";

const TOAST_KEY = "cssrs-prompt";

export function useCSSRSPromptToastCallback() {
  const setDrawerState = useSetAtom(drawerStateAtom);
  const room = useAtomValue(roomAtom);

  useEffect(
    function clearToastOnRoomDisconnect() {
      if (!room) {
        toast.close(TOAST_KEY);
      }
    },
    [room],
  );

  return useCallback(
    (
      visitorName: string,
      patientChart?: {
        preferredShortName?: string | null;
        measureBundles?: MeasureBundleObject[];
      } | null,
    ) => {
      if (!patientChart) {
        return;
      }

      if (
        !patientChart.measureBundles ||
        !shouldPromptForCSSRS(patientChart?.measureBundles ?? [])
      ) {
        return;
      }

      toast.enqueue(
        ({ closeToast, ...ariaProps }) => {
          return (
            <CSSRSPromptToast
              {...ariaProps}
              patientName={patientChart.preferredShortName || visitorName}
              onAdministerCSSRS={() => {
                setDrawerState(ProviderDrawerState.CSSRS_FORM);
                closeToast();
              }}
            />
          );
        },
        { key: TOAST_KEY, timeout: Infinity },
      );
    },
    [setDrawerState],
  );
}
